module.exports = __webpack_public_path__ + "static/img/album-status-1.0ea2c338.png";